'use strict'
import store from '@/store'
import { merge } from 'lodash-es'
import { promoteUrl } from "@/utils/url";

const actions = {
  /** 关闭登入注册视窗 **/
  async clearLoginBox ({ commit, state }) {
    commit('setLoginBox', { show: false })
  },
  /** 显示登入注册视窗 **/
  async showLoginBox ({ commit, state }, options) {
    window.location = promoteUrl() + '/member_vue.php?platform=2&method=login&back=' + encodeURIComponent(document.URL)
    // let popup = { show: true }
    //
    // commit('setLoginBox', merge(popup, options))
  },
  /** 簽到彈窗 **/
  showSignPopup ({ commit, state }, options) {
    let popup = { show: true }
    // 未登入
    if (popup.show && !store.state.user.isLogin) {
      // 登入提示
      // store.dispatch('common/showLoginBox')
      window.location = promoteUrl() + '/member_vue.php?platform=2&method=login&back=' + encodeURIComponent(document.URL)
    } else {
      commit('setSignPopup', merge(popup, options))
    }
  },
  /** 邀请码彈窗 **/
  showPalcodePopup ({ commit }, options) {
    let popup = { show: true }
    // 未登入
    if (popup.show && !store.state.user.isLogin) {
      // 登入提示
      store.dispatch('common/showLoginBox')
    } else {
      commit('setPalcodePopup', merge(popup, options))
    }
  },
  showPalcodeSuccessPopup ({ commit }, options) {
    let popup = { show: true }

    commit('setPalcodeSuccessPopup', merge(popup, options))
  },
  /** 修改昵稱弹窗 **/
  showNicknameEditPopup ({ commit }, options) {
    let popup = { show: true }
    // 未登入
    if (popup.show && !store.state.user.isLogin) {
      // 登入提示
      store.dispatch('common/showLoginBox')
    } else {
      commit('setNicknameEditPopup', merge(popup, options))
    }
  },
  /** 上傳頭像弹窗 **/
  showAvatarUploadPopup ({ commit }, options) {
    let popup = { show: true }
    // 未登入
    if (popup.show && !store.state.user.isLogin) {
      // 登入提示
      store.dispatch('common/showLoginBox')
    } else {
      commit('setAvatarUploadPopup', merge(popup, options))
    }
  },
  handleLoading({ commit }, value) {
    const obj = value ?
      { show: true } :
      { show: false, mask: false }
    commit('setLoading', obj)
  },
  closeRedirectLoadingInterval({ state, dispatch }) {
    dispatch("handleLoading", false)
    return;
    // 返回时 loading 仍在故跑计时器来判断
    const max = 10
    let count = 0
    let savedTIme = new Date().getTime()
    let interval = setInterval(() => {
      const currentTime = new Date().getTime()
      const diff = ((currentTime - savedTIme) / 1000).toFixed(1)
      console.log(state.loading, diff)
      count++
      if (!state.loading.show || +diff > 0.5 || count > max) {
        dispatch("handleLoading", false)
        clearInterval(interval)
      }
      savedTIme = new Date().getTime()
    }, 500);
  },
  // 關閉世界盃浮窗之標記
  closeFifaFlag({ state, commit }, value) {
    commit("setShowFifaFlag", value.show)
    commit("setShowFifaForce", value.force)
  }
}

export default actions
